import { ApiError } from "../types";

export async function sendApiRequest<T, V>(
  url: `/${string}`,
  body?: V
): Promise<T | ApiError> {
  try {
    const res = await fetch(`/api${url}`, {
      method: body ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok || res.status === 202) {
      const errorText = await res.text();
      return {
        status: res.status,
        message: errorText,
      } as ApiError;
    }

    const jsonResponse = await res.json();

    return jsonResponse as T;
  } catch (error) {
    return {
      status: 0,
      message: error instanceof Error ? error.message : 'Unknown error occurred',
    } as ApiError;
  }
}

export function isApiError<T>(result: T | ApiError): result is ApiError {
  return typeof result === 'object' && result !== null && 'status' in result && 'message' in result;
}
